import React, {Component} from "react";
import {connect} from "react-redux";
import {ReactSVG} from "react-svg";

import imgClose from "../../../resources/img/svgicons/cross.svg";

export const MODAL_VARIANT_PRIMARY = "MODAL_VARIANT_PRIMARY";
export const MODAL_VARIANT_HEADERLESS = "MODAL_VARIANT_HEADERLESS";
export const MODAL_VARIANT_WARNING = "MODAL_VARIANT_WARNING";

export const MODAL_VARIANTS = [MODAL_VARIANT_PRIMARY, MODAL_VARIANT_HEADERLESS, MODAL_VARIANT_WARNING];

/**
 * @class Modal
 *
 * Displays a generic modal
 *
 * [Confluence page]{@link https://deso.atlassian.net/wiki/spaces/Redlike/pages/51937320/Modal}
 *
 * @param {number} modalId - id from the modal object
 * @param {function} onClose - called on close cross click
 * @param {string} [variant] - modal variant
 * @param {ModalSection} [header] - header content
 * @param {ModalSection} [subHeader] - sub-header content
 * @param {ModalSection} [content] - content content
 * @param {ModalSection} [footer] - footer content
 * @param {string} [className] - CSS class names to be applied to modal
 * @param {object} [styles] - styles to be applied to the modal - supports: minHeight, minWidth, height, width, maxWidth, maxHeight
 *
 * @example
 *  <Modal
 *      modalId={this.props.id}
 *      header={modelHelper.buildModalSection("Example")}
 *      onClose={this.handleCloseModalClick}
 *      content={modelHelper.buildModalSection("EXAMPLE")}
 *      footer={
 *             modelHelper.buildModalSection(
 *                 <CancelButton onClick={this.handleCloseModalClick} />
 *             )
 *        }
 *      styles={{
 *            minWidth: "40%"
 *      }}
 *  />
 */
class Modal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOnTop: this.isOnTop()
        };
    }

    isOnTop = () => {
        if (this.props.manualScan || this.props.onTop === false) {
            return false;
        }

        // if modalId not passed display on top by default (precaution)
        if (!this.props.modalId) {
            return true;
        }

        if (this.props.modalList.length === 0) {
            return false;
        }

        return this.props.modalList[this.props.modalList.length - 1].id === this.props.modalId;
    };

    componentDidUpdate() {
        const isOnTop = this.isOnTop();

        if (this.state.isOnTop !== isOnTop) {
            this.setState({
                isOnTop: isOnTop
            });
        }
    }

    renderHeader = () => {
        return (
            <div
                className={
                    "general-modal-header " +
                    (this.props.header?.className ?? "") +
                    (this.props.header?.data ? "" : "empty-header")
                }
            >
                {!this.props.closeHidden ? (
                    <div className="general-modal-close" onClick={this.props.onClose}>
                        <ReactSVG src={imgClose} className="close-img" />
                    </div>
                ) : null}
                {this.props.header?.data ?? ""}
            </div>
        );
    };

    renderSubHeader = () => {
        return (
            <div className={"general-modal-subheader " + (this.props.subHeader.className ?? "")}>
                {this.props.subHeader.data ?? ""}
            </div>
        );
    };

    renderContent = () => {
        return (
            <div className={"general-modal-content " + (this.props.content.className ?? "")}>
                {this.props.content.data ?? ""}
            </div>
        );
    };

    renderFooter = () => {
        return (
            <div className={"general-modal-footer " + (this.props.footer.className ?? "")}>
                {this.props.footer.data ?? ""}
            </div>
        );
    };

    getModalClass = () => {
        let variantClassName;
        switch (this.props.variant) {
            case MODAL_VARIANT_PRIMARY:
                variantClassName = "primary-modal ";
                break;
            case MODAL_VARIANT_HEADERLESS:
                variantClassName = "headerless-modal ";
                break;
            case MODAL_VARIANT_WARNING:
                variantClassName = "warning-modal ";
                break;
            default:
                variantClassName = "primary-modal ";
                break;
        }
        return "general-modal " + variantClassName + (this.state.isOnTop ? "top-modal " : "");
    };

    render() {
        return (
            <div
                onClick={this.props.onClick}
                className={this.getModalClass() + (this.props.className ?? "")}
                style={{
                    height: this.props.styles?.height,
                    width: this.props.styles?.width,
                    minHeight: this.props.styles?.minHeight,
                    minWidth: this.props.styles?.minWidth,
                    maxHeight: this.props.styles?.maxHeight,
                    maxWidth: this.props.styles?.maxWidth,
                    zIndex: this.props.styles?.zIndex
                }}
            >
                {this.renderHeader()}
                {this.props.subHeader && this.renderSubHeader()}
                {this.props.content && this.renderContent()}
                {this.props.footer && this.renderFooter()}
            </div>
        );
    }
}
const mapStoreToProps = (store) => {
    return {
        modalList: store.navigation.modalList,
        manualScan: store.barcode.manualScan
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default Modal = connect(mapStoreToProps, mapDispatchToProps)(Modal);
